import { Configuration, LogLevel } from '@azure/msal-browser';

/**
 * MSAL Configuration for Staff Authentication
 *
 * Azure AD B2C configuration for staff members accessing the Operations Center.
 * This is separate from the renter authentication (which uses a different tenant/policy).
 *
 * Environment variables required:
 * - VITE_AZURE_AD_CLIENT_ID: Application (client) ID from Azure AD app registration
 * - VITE_AZURE_AD_AUTHORITY: Authority URL (e.g., https://login.microsoftonline.com/{tenant-id})
 * - VITE_AZURE_AD_REDIRECT_URI: Redirect URI (e.g., http://localhost:3001)
 */

const clientId = import.meta.env.VITE_AZURE_AD_CLIENT_ID || 'YOUR_CLIENT_ID';
const authority = import.meta.env.VITE_AZURE_AD_AUTHORITY || 'https://login.microsoftonline.com/common';
const redirectUri = import.meta.env.VITE_AZURE_AD_REDIRECT_URI || window.location.origin;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

/**
 * Scopes to request during login
 */
export const loginRequest = {
  scopes: ['User.Read'],
};

/**
 * Scopes for API access
 */
export const apiRequest = {
  scopes: [`api://${clientId}/access_as_staff`],
};
